import React from 'react'
import ContentLayout from '../../components/ContentLayout/ContentLayout'
import HomeDetails from './sections/HomeDetails'
import ImageContainer from '../../components/ImageContainer/ImageContainer'
import { BreadCrumb } from '../../components/Breadcrumb/BreadCrumb'

export default function HomePage() {
	return (
		<ContentLayout
			BreadCrumbsTrail={<BreadCrumb pathname="/home" />}
			LeftSide={<HomeDetails />}
			RightSide={<ImageContainer src="/assets/images/home.png" />}
			hideOnMobile="right"
		/>
	)
}
